import clone from 'clone';
import actions from './actions';
import AudioNotification from '@iso/components/AudioNotification';
import Notification from '@iso/components/Notification';
import IntlMessages from '@iso/components/utility/intlMessages';
import React from 'react';
import { orderStatuses } from './config';
import moment from 'moment';

const generateRandomNumber = (max) => {
  return Math.floor(Math.random() * max) + 1;
};

function getRandomDate() {
  const maxDate = Date.now();
  const timestamp = Math.floor(Math.random() * maxDate);
  return new Date(timestamp).toLocaleDateString();
}

const disputes = [
  {
    orderNumber: `731359-788836`,
    restaurant: 'restaurantName',
    channel: 'DSP',
    customerName: 'John',
    net: '26$',
    disputedAmount: '$20',
    deadline: '3 days',
    subject: 'Not delivered',
    messages: [
      {
        text: 'Hello',
        myMessage: true,
      },
    ],
    status: 'Pending',
  },
  {
    orderNumber: `731359-788837`,
    restaurant: 'restaurantName1',
    channel: 'DSP',
    customerName: 'John',
    net: '26$',
    disputedAmount: '$20',
    deadline: '3 days',
    subject: 'Not delivered',
    messages: [
      {
        text: 'Hello',
        myMessage: true,
      },
    ],
    status: 'Pending',
  },
  {
    disputeId: `#${generateRandomNumber(1000000)}-${generateRandomNumber(
      1000000
    )}`,
    date: getRandomDate(),
    name: 'John',
    phone: '+1(252)555-78-56',
    email: 'antonkerch555@gmail.com',
    subject: 'Not delivered',
    status: 'Resolved',
  },
  {
    disputeId: `#${generateRandomNumber(1000000)}-${generateRandomNumber(
      1000000
    )}`,
    date: getRandomDate(),
    name: 'John',
    phone: '+1(252)555-78-56',
    email: 'antonkerch555@gmail.com',
    subject: 'Refund',
    status: 'Resolved',
  },
  {
    disputeId: `#${generateRandomNumber(1000000)}-${generateRandomNumber(
      1000000
    )}`,
    date: getRandomDate(),
    name: 'John',
    phone: '+1(252)555-78-56',
    email: 'antonkerch555@gmail.com',
    subject: 'Wrong order',
    status: 'Pending',
  },
  {
    disputeId: `#${generateRandomNumber(1000000)}-${generateRandomNumber(
      1000000
    )}`,
    date: getRandomDate(),
    name: 'John',
    phone: '+1(252)555-78-56',
    email: 'antonkerch555@gmail.com',
    subject: 'Not delivered',
    status: 'Pending',
  },
];

const initState = {
  restaurantOrders: [],
  yaOrders: [],
  dcOrders: [],
  wlOrders: [],
  qrOrders: [],
  allRestaurantOrders: [],
  allDispute: [],
  disputeHistory: [],
  allCrm: [],
  allBlog: [],
  allNews: [],
  disputeButtonColor: false,
  notificationOrder: {},
  orderCost: 0,
  initialWebSocketOrders: false,
  initialRestaurantOrders: false,
  initialRestaurantAllOrders: false,
  currentRestaurantOrder: {},
  isNewRestaurantOrder: false,
  isFetching: false,
  isNewOrder: false,
  orderDelivery: [],
  widgetsData: {},
  disputeModal: false,
  newDisputeModal: false,
  disputesList: [disputes[0]],
  refundModal: false,
  confirmRefundModal: false,
  refundablePrice: 0,
  refundableId: '',
  refundableReason: '',
  refundableComment: '',
  refundedIds: [''],
  refundedReason: '',
  refundPrice: 0,
  orderId: '',
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.SET_REFUNDABLE_ORDER: {
      return {
        ...state,
        refundableId: action.id,
        refundablePrice: action.price,
      };
    }
    case actions.SET_REFUNDABLE_DETAILS: {
      return {
        ...state,
        refundableReason: action.payload.reason,
        refundableComment: action.payload.comment,
      };
    }
    case actions.SEND_REFUND_REQUEST__SUCCESS: {
      console.log('SEND_REFUND_REQUEST__SUCCESS', action);
      return {
        ...state,
      };
    }
    case actions.ADD_REFUNDED_ID: {
      console.log('ADD_REFUNDED_ID', action.payload);
      return {
        ...state,
        refundedIds: [...state.refundedIds, action.payload.id],
      };
    }
    case actions.SET_REFUNDED_REASON: {
      return {
        ...state,
        refundedReason: action.payload.reason,
      };
    }
    case actions.SET_REFUND_PRICE: {
      return {
        ...state,
        refundPrice: action.price,
      };
    }
    case actions.SHOW_DISPUTE_MODAL: {
      return {
        ...state,
        disputeModal: true,
      };
    }
    case actions.HIDE_DISPUTE_MODAL: {
      return {
        ...state,
        disputeModal: false,
      };
    }
    // case actions.CREATE_DISPUTE: {
    //   return {
    //     ...state,
    //     disputesList: [...state.disputesList, action.dispute],
    //   };
    // }
    case actions.CHANGE_DISPUTE_BUTTON_COLOR: {
      return {
        ...state,
        disputeButtonColor: true,
      };
    }
    case actions.SEND_DISPUTE_MESSAGE: {
      const { chatId, message } = action.payload;
      // console.log('SEND_DISPUTE_MESSAGE', action.payload);
      const updatedDisputes = state.disputesList.map((dispute) => {
        if (dispute.id === chatId) {
          // Add the new message to the existing array of messages
          return {
            ...dispute,
            messages: [
              ...dispute.messages,
              {
                text: message,
                myMessage: true,
              },
            ],
          };
        }
        return dispute;
      });
      return {
        ...state,
        disputesList: [...updatedDisputes],
      };
    }
    case actions.SHOW_NEW_DISPUTE_MODAL: {
      return {
        ...state,
        newDisputeModal: true,
      };
    }
    case actions.HIDE_NEW_DISPUTE_MODAL: {
      return {
        ...state,
        newDisputeModal: false,
      };
    }
    case actions.FETCH_GET_ALL_CRM_SUCCESS: {
      return {
        ...state,
        allCrm: action.payload,
        // initialRestaurantAllOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        // isNewOrder: true,
      };
    }
    case actions.FETCH_GET_ALL_BLOG_SUCCESS: {
      // console.log('called');
      return {
        ...state,
        allBlog: action.payload,
        // initialRestaurantAllOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        // isNewOrder: true,
      };
    }
    case actions.FETCH_GET_ALL_NEWS_SUCCESS: {
      // console.log('called');
      return {
        ...state,
        allNews: action.payload,
        // initialRestaurantAllOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        // isNewOrder: true,
      };
    }
    case actions.FETCH_GET_ALL_DISPUTE_SUCCESS: {
      return {
        ...state,
        allDispute: action.payload,
        // initialRestaurantAllOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        // isNewOrder: true,
      };
    }
    case actions.FETCH_DISPUTE_HISTORY_SUCCESS: {
      return {
        ...state,
        disputeHistory: action.payload,
        // initialRestaurantAllOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        // isNewOrder: true,
      };
    }
    case actions.SHOW_REFUND_MODAL: {
      return {
        ...state,
        refundModal: true,
      };
    }
    case actions.HIDE_REFUND_MODAL: {
      return {
        ...state,
        refundModal: false,
      };
    }
    case actions.SHOW_CONFIRM_REFUND_MODAL: {
      return {
        ...state,
        confirmRefundModal: true,
      };
    }
    case actions.HIDE_CONFIRM_REFUND_MODAL: {
      return {
        ...state,
        confirmRefundModal: false,
      };
    }
    case actions.FETCH_GET_ACTIVE_ORDERS_START: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case actions.FETCH_GET_ACTIVE_ORDERS_SUCCESS: {
      console.log('FETCH_GET_ACTIVE_ORDERS_SUCCESS');
      return {
        ...state,
        allRestaurantOrders: action.payload,
        initialRestaurantAllOrders: true,
        isNewRestaurantOrder: false,
        isFetching: false,
        isNewOrder: true,
      };
    }
    case actions.FETCH_GET_WIDGETS_DATA_SUCCESS: {
      console.log('FETCH_GET_WIDGETS_DATA_SUCCESS');
      return {
        ...state,
        widgetsData: action.payload,
      };
    }
    case actions.FETCH_GET_ACTIVE_ORDERS_FAILURE:
    case actions.FETCH_GET_WIDGETS_DATA_FAILURE: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case actions.SUBSCRIBE_RESTAURANT_ORDERS: {
      return {
        ...state,
        initialWebSocketOrders: true,
      };
    }
    case actions.REQUEST_POSTS_RESTAURANT_ORDERS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case actions.RECEIVE_POSTS_RESTAURANT_ORDERS: {
      const orders = action.restaurantOrders.map(function (ord) {
        return { ...ord, key: ord.id };
      });
      return {
        ...state,
        allRestaurantOrders: orders,
        initialRestaurantAllOrders: true,
        isNewRestaurantOrder: false,
        isFetching: false,
        isNewOrder: true,
      };
    }
    case actions.REQUEST_SUBSCRIBE_RESTAURANT_ORDERS: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case actions.RECEIVE_SUBSCRIBE_RESTAURANT_ORDERS: {
      const order = action.restaurantOrders;
      const orders = clone(state.restaurantOrders).slice();
      /*
      const dcOrders = state.dcOrders.slice();
      const yaOrders = state.yaOrders.slice();
      const wlOrders = state.wlOrders.slice();
      const qrOrders = state.qrOrders.slice();

      switch (order.aggregatorId) {
        case 1: {
          /!*Delivery Club*!/
          const agrIdx = dcOrders.findIndex((b) => b.id === order.id);
          if (agrIdx === -1) {
            dcOrders.unshift(order);
          } else if (dcOrders[agrIdx]?.status !== order?.status) {
            dcOrders[agrIdx] = order;
          }
          break;
        }
        case 2: {
          /!*YandexEda*!/
          const agrIdx = yaOrders.findIndex((b) => b.id === order.id);
          if (agrIdx === -1) {
            yaOrders.unshift(order);
          } else if (yaOrders[agrIdx]?.status !== order?.status) {
            yaOrders[agrIdx] = order;
          }
          break;
        }
        case 3: {
          /!*White Label*!/
          const agrIdx = wlOrders.findIndex((b) => b.id === order.id);
          if (agrIdx === -1) {
            wlOrders.unshift(order);
          } else if (wlOrders[agrIdx]?.status !== order?.status) {
            wlOrders[agrIdx] = order;
          }
          break;
        }
        case 4: {
          /!*QR*!/
          const agrIdx = qrOrders.findIndex((b) => b.id === order.id);
          if (agrIdx === -1) {
            qrOrders.unshift(order);
          } else if (qrOrders[agrIdx]?.status !== order?.status) {
            qrOrders[agrIdx] = order;
          }
          break;
        }
        default:
          break;
      }
*/

      const pIdx = orders.findIndex((b) => b.id === order.id);

      if (pIdx === -1) {
        orders.unshift(order);
        if (
          (action.restaurantOrders.status === 'created' ||
            action.restaurantOrders.status === 'accepted') &&
          typeof action.restaurantOrders.isFirstLoad === 'undefined'
        ) {
          AudioNotification(
            'success',
            <IntlMessages id="activeOrders.notification.newOrder.title" />,
            <IntlMessages
              id="activeOrders.notification.newOrder.caption"
              values={{ orderId: action.restaurantOrders.originalOrderId }}
            />
          );
        }
      } else if (orders[pIdx].status !== order.status) {
        Notification(
          'info',
          <IntlMessages id="activeOrders.notification.statusChange.title" />,
          <IntlMessages
            id="activeOrders.notification.statusChange.caption"
            values={{
              orderId: order.originalOrderId,
              old: orderStatuses.get(orders[pIdx].status),
              new: orderStatuses.get(order.status),
            }}
          />,
          60
        );
        orders[pIdx] = order;
      } else if (
        orders[pIdx].deliveryPrice?.claimId !== order.deliveryPrice?.claimId
      ) {
        /*        Notification(
          'info',
          <IntlMessages id="activeOrders.notification.delivery.title" />,
          <IntlMessages
            id="activeOrders.notification.delivery.caption"
            values={{
              orderId: order.originalOrderId,
              amount: order.deliveryPrice?.price,
            }}
          />,
          60
        );*/
        orders[pIdx] = order;
      } else if (
        orders[pIdx].courier?.name !== order.courier?.name ||
        orders[pIdx].courier?.phone !== order.courier?.phone
      ) {
        orders[pIdx] = order;
      } else if (
        orders[pIdx].deliveryPrice?.id !== order.deliveryPrice?.id ||
        orders[pIdx].deliveryPrice?.lat !== order.deliveryPrice?.lat ||
        orders[pIdx].deliveryPrice?.long !== order.deliveryPrice?.long ||
        orders[pIdx].deliveryPrice?.arrivedTime !==
          order.deliveryPrice?.arrivedTime
      ) {
        orders[pIdx] = order;
      } else if (orders[pIdx].pending !== order.pending) {
        orders[pIdx] = order;
      }
      return {
        ...state,
        restaurantOrders: orders,
        currentRestaurantOrder: order,
        // initialRestaurantOrders: true,
        // isNewRestaurantOrder: false,
        // isFetching: false,
        isNewOrder: true,
      };
    }
    case actions.CLEAR_RESTAURANT_ORDERS: {
      return {
        ...state,
        initialRestaurantOrders: true,
        yaOrders: [],
        dcOrders: [],
        wlOrders: [],
        currentRestaurantOrder: {},
        restaurantOrders: [],
      };
    }
    case actions.RECEIVE_NOTIFICATION_RESTAURANT_ORDERS: {
      const orders = state.restaurantOrders;
      const index = orders
        .map((order) => order.id)
        .indexOf(parseInt(action.orderId));
      let order = orders[index];

      if (
        action.notificationOrder &&
        order.status !== 'on_the_way' &&
        order.status !== 'picked_up'
      ) {
        if (typeof action.notificationOrder.isFirstLoad === 'undefined')
          Notification(
            'info',
            <IntlMessages id="activeOrders.notification.courier.title" />,
            <IntlMessages
              id="activeOrders.notification.courier.caption"
              values={{
                name: order.courier.name,
                orderId: order.originalOrderId,
              }}
            />,
            0
          );
      } else
        return {
          ...state,
        };
      order.notification = action.notificationOrder.type;
      return {
        ...state,
        initialRestaurantOrders: true,
        currentRestaurantOrder: clone(order),
      };
    }
    case actions.UPDATE_RESTAURANT_ORDERS:
      const currentRestaurantOrder = action.order
        ? action.order
        : state.currentRestaurantOrder;

      return {
        ...state,
        restaurantOrders: action.restaurantOrders,
        initialRestaurantOrders: true,
        currentRestaurantOrder: clone(currentRestaurantOrder),
        isNewRestaurantOrder: false,
        isFetching: false,
      };
    case actions.UPDATE_ORDER: {
      const orders = state.restaurantOrders;
      const index = orders.map((order) => order.id).indexOf(action.id);
      if (index !== -1) {
        const order = orders[index];
        order.status = action.status;
        order.statusHistory.push({
          status: action.status,
          date: new Date(moment()).toISOString(),
        });
        return {
          ...state,
          initialRestaurantOrders: true,
          currentRestaurantOrder: clone(order),
        };
      } else if (index === -1) {
        return {
          ...state,
          initialRestaurantOrders: true,
        };
      }
      break;
    }
    case actions.UPDATE_PROMO_STATUS: {
      const orders = state.restaurantOrders;
      const index = orders.findIndex(
        (order) =>
          order.promotions &&
          order.promotions.some((promo) => promo.name === action.promoName)
      );

      // Check if the index was found
      if (index !== -1) {
        const order = orders[index];
        // Find the promotion within the order
        const promoIndex = orders[index].promotions.findIndex(
          (promo) => promo.name === action.promoName
        );

        // Update the isScan of the found promotion
        if (promoIndex !== -1) {
          orders[index].promotions[promoIndex].isScan = true; // Change to true or desired value
        }
        return {
          ...state,
          initialRestaurantOrders: true,
          currentRestaurantOrder: clone(order),
          orderId: order.id,
        };
      } else if (index === -1) {
        return {
          ...state,
          initialRestaurantOrders: true,
        };
      }
      break;
    }
    case actions.UPDATE_ORDER_STATUS: {
      const currentOrder = {
        status: action.status,
        ...state.currentRestaurantOrder,
      };
      return {
        ...state,
        initialRestaurantOrders: true,
        currentRestaurantOrder: clone(action.order),
      };
    }
    case actions.DELIVERY_ORDER: {
      const orders = state.restaurantOrders;
      const index = orders
        .map((order) => order.id)
        .indexOf(parseInt(action.restaurantOrders.id));

      if (index !== -1) {
        const order = orders[index];
        order.status = action.restaurantOrders.status;
        Notification(
          'info',
          <IntlMessages id="activeOrders.notification.statusChange.title" />,
          <IntlMessages
            id="activeOrders.notification.statusChange.caption"
            values={{
              orderId: order.originalOrderId,
              old: orderStatuses.get('on_the_way'),
              new: orderStatuses.get(order.status),
            }}
          />,
          60
        );
        state.restaurantOrders.splice(index, 1);
        return {
          ...state,
          initialRestaurantOrders: true,
          currentRestaurantOrder: clone(order),
        };
      } else if (index === -1) {
        return {
          ...state,
          initialRestaurantOrders: true,
        };
      }
      break;
    }
    case actions.RESTAURANT_CANCELLED_ORDER:
    case actions.CUSTOMER_CANCELLED_ORDER: {
      const orders = state.restaurantOrders;
      const index = orders
        .map((order) => order.id)
        .indexOf(parseInt(action.restaurantOrders.id));

      if (index !== -1) {
        const dcOrders = state.dcOrders.slice();
        const yaOrders = state.yaOrders.slice();
        const wlOrders = state.wlOrders.slice();

        console.log({ dcOrders, yaOrders, wlOrders });

        switch (orders[index].aggregatorId) {
          case 1: {
            /*Delivery Club*/
            const agrIdx = dcOrders.findIndex((b) => b.id === orders[index].id);
            if (agrIdx !== -1) state.dcOrders.splice(agrIdx, 1);
            break;
          }
          case 2: {
            /*YandexEda*/
            const agrIdx = yaOrders.findIndex((b) => b.id === orders[index].id);
            if (agrIdx !== -1) state.yaOrders.splice(agrIdx, 1);
            break;
          }
          case 3: {
            /*White Label*/
            const agrIdx = wlOrders.findIndex((b) => b.id === orders[index].id);
            if (agrIdx !== -1) state.wlOrders.splice(agrIdx, 1);
            break;
          }
          default:
            break;
        }

        if (type === actions.CUSTOMER_CANCELLED_ORDER)
          Notification(
            'warning',
            <IntlMessages
              id="activeOrders.notification.clientCancel.title"
              values={{
                orderId: orders[index].originalOrderId,
              }}
            />,
            <IntlMessages
              id="activeOrders.notification.clientCancel.caption"
              values={{
                orderId: orders[index].originalOrderId,
              }}
            />
          );
        else if (type === actions.RESTAURANT_CANCELLED_ORDER)
          Notification(
            'warning',
            <IntlMessages
              id="activeOrders.notification.restaurantCancel.title"
              values={{
                orderId: orders[index].originalOrderId,
              }}
            />,
            <IntlMessages
              id="activeOrders.notification.restaurantCancel.caption"
              values={{
                orderId: orders[index].originalOrderId,
              }}
            />
          );
        state.restaurantOrders.splice(index, 1);
        return {
          ...state,
          initialRestaurantOrders: true,
        };
      } else if (index === -1) {
        return {
          ...state,
          initialRestaurantOrders: true,
        };
      }
      break;
    }

    case actions.CLOSE_WEB_SOCKET:
      actions.closeWsOrder();
      return {
        ...initState,
      };
    case actions.LOGOUT:
      console.log('ORDERS LOGOUT');
      return {
        ...initState,
      };

    case actions.REQUEST_POSTS_ORDER_DELIVERY_COST: {
      return {
        ...state,
      };
    }
    case actions.RECEIVE_POSTS_ORDER_DELIVERY_COST: {
      const orderCost = action.cost;
      return {
        ...state,
        orderCost: orderCost,
      };
    }
    default:
      return state;
  }
}
